import React from 'react';
import Slider from 'react-slick';
import { array, string, node, bool, number, func, oneOfType } from 'prop-types';
import { sendMixPanelEvent } from '../utils/biEvents';
import { createSliderSettings } from '../utils/SlickSlider';
import '../style.scss';

const SlickSlider = (props) => {

    const afterChange = (mixPanelEventName, index) => {
        if (mixPanelEventName) {
            sendMixPanelEvent({ eventName: mixPanelEventName });
        }

        const { afterChange: afterChangeCallback } = props;
        afterChangeCallback(index);

    };

    const {
        items,
        Component,
        slidesToShow,
        sliderBreakpoints,
        isInfinite,
        initialSlide,
        useDots,
        useArrows,
        autoplay,
        autoplaySpeed,
        mixpanelEvent,
        onArrowClick,
        smallArrows,
        slidesToScroll,
        speed,
        easing,
        useTransform
    } = props;

    const sliderSettings = createSliderSettings({
        breakpoints: sliderBreakpoints,
        slidesToShow,
        isInfinite,
        initialSlide,
        useDots,
        useArrows,
        smallArrows,
        onArrowClick,
        autoplay,
        autoplaySpeed,
        slidesToScroll,
        speed,
        easing,
        useTransform
    });

    return (
        <Slider className="slick-slider" {...sliderSettings}
            afterChange={(index) => afterChange(mixpanelEvent, index)}>
            {
                items.map((props, index) => (
                    <Component key={index} {...props} pos={index + 1}/>
                ))
            }
        </Slider>
    );
};

SlickSlider.propTypes = {
    items: array.isRequired,
    Component: oneOfType([
        node,
        func
    ]).isRequired,
    slidesToShow: number,
    initialSlide: number,
    sliderBreakpoints: array,
    isInfinite: bool,
    afterChange: func,
    useDots: bool,
    useArrows: bool,
    mixpanelEvent: string,
    autoplay: bool,
    autoplaySpeed: number,
    smallArrows: bool,
    onArrowClick: func,
    slidesToScroll: number,
    speed: number,
    easing: string,
    useTransform: bool
};

export default SlickSlider;
